export default "__VITE_ASSET__a40a5c01__"